













import { Component, Vue } from 'vue-property-decorator'
import LoginLine from './components/LoginLine.vue'
import Banner from './components/Banner.vue'
import RegisterBox from './components/RegisterBox.vue'
import RegisterStep from './components/RegisterStep.vue'
import Dialog from '@/components/Dialog/index.vue'
import analytics from '@/firebase/firebase'
import { getDevice } from '@/utils/tool'

@Component({
    components: {
        LoginLine,
        Banner,
        RegisterBox,
        RegisterStep,
        Dialog,
    },
})
export default class LazadaH5 extends Vue {
    mounted() {
        analytics('lazadaH5_homePage') // 数据统计
        analytics(`lazadaH5_homePage_${getDevice()}`)
    }
}
